import Transform from "@ember-data/serializer/transform";
import ConsultationFrequency from "parog-web/models/consultation/consultation-frequency";

type SerializedConsultationFrequency = ReturnType<
  ConsultationFrequenciesTransform["serialize"]
>;

export default class ConsultationFrequenciesTransform extends Transform {
  override deserialize(serialized: SerializedConsultationFrequency[]) {
    return serialized.map(
      item =>
        new ConsultationFrequency(
          item["key"],
          item["enabled"],
          item["frequency"],
          item["type"],
          item["comment"]
        )
    );
  }

  override serialize(consultationFrequencies: ConsultationFrequency[]) {
    return consultationFrequencies.map(
      ({ key, enabled, frequency, type, comment }) => ({
        key,
        enabled,
        frequency,
        type,
        comment
      })
    );
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "consultation-frequencies": ConsultationFrequenciesTransform;
  }
}
